import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BFormInput } from "bootstrap-vue";
import { faNetworkWired } from "font-awesome-6";
import { computed, ref } from "vue";
import Filtering, {} from "@/utils/filtering";
import BreadcrumbHeading from "@/components/Common/BreadcrumbHeading.vue";
import Heading from "@/components/Common/Heading.vue";
import ListHeader from "@/components/Common/ListHeader.vue";
import SourceOptionCard from "@/components/ConfigTemplates/SourceOptionCard.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ObjectStoreBadges from "@/components/ObjectStore/ObjectStoreBadges.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SourceOptionsList',
    props: {
        title: null,
        listId: null,
        loading: { type: Boolean },
        gridView: { type: Boolean },
        routePath: null,
        breadcrumbItems: null,
        optionTypes: null,
        validFilters: null,
        templates: null,
        showBadges: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const filterText = ref("");
        const templatesFilter = computed(() => new Filtering(props.validFilters, undefined));
        const filteredTemplates = computed(() => {
            return props.templates.filter((tp) => {
                return (filterText.value === "" ||
                    tp.name?.toLowerCase().includes(filterText.value.toLowerCase()) ||
                    tp.type === templatesFilter.value.getFilterValue(filterText.value, "type"));
            });
        });
        function getOptionType(type) {
            const optionType = props.optionTypes[type];
            return {
                title: optionType?.message ?? type,
                icon: optionType?.icon ?? faNetworkWired,
            };
        }
        return { __sfc: true, props, filterText, templatesFilter, filteredTemplates, getOptionType, BAlert, BFormInput, BreadcrumbHeading, Heading, ListHeader, SourceOptionCard, LoadingSpan, ObjectStoreBadges };
    }
});
